<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Scheduler</li>
  </app-tabs>
  <app-scheduler-dashboard class="flex-control calendar-component" [hidden]="tabs_service.is_active()"></app-scheduler-dashboard>
</div>
